// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"237":"pages","945":"dashboard"}[chunkId] || chunkId) + "." + {"237":"80628a4e","945":"80628a4e","5953":"9f2ad225"}[chunkId] + ".chunk.css";
};